if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-sticky-button]');
        this.label = this.querySelector('[data-sticky-label]');
        this.button.addEventListener('click', () => this.realButton()?.click());

        const target = this.realButton();
        if (!target || !('IntersectionObserver' in window)) return;

        // Show only after the real button has scrolled up past the top of the screen.
        this.observer = new IntersectionObserver(([entry]) => {
          this.toggle(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
        this.observer.observe(target);

        // Follow the real button's label and disabled state (variant changes re-render it).
        this.mirror = new MutationObserver(() => this.sync());
        this.mirror.observe(target, { attributes: true, childList: true, subtree: true, characterData: true });
        this.sync();

        // Keep the price and image in step with the selected variant.
        if (typeof subscribe === 'function') {
          this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.dataset.sectionId) return;
            this.syncVariant(event.data);
          });
        }
      }

      syncVariant({ html, variant }) {
        const price = html?.getElementById(`price-${this.dataset.sectionId}`)?.querySelector('.price');
        if (price) this.querySelector('[data-sticky-price]').innerHTML = price.outerHTML;

        const src = variant?.featured_media?.preview_image?.src;
        const image = this.querySelector('[data-sticky-image]');
        if (src && image) {
          const url = new URL(src, window.location.href);
          url.searchParams.set('width', '240');
          image.removeAttribute('srcset');
          image.src = url.toString();
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.mirror?.disconnect();
        this.variantUnsubscriber?.();
      }

      realButton() {
        return document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
      }

      sync() {
        const target = this.realButton();
        if (!target) return;
        const text = target.querySelector('span')?.textContent.trim();
        if (text) this.label.textContent = text;
        this.button.disabled = target.disabled || target.getAttribute('aria-disabled') === 'true';
      }

      toggle(show) {
        if (show) {
          this.hidden = false;
          // Next frame, so the slide-in transition runs from the hidden position.
          requestAnimationFrame(() => this.classList.add('is-visible'));
        } else {
          this.classList.remove('is-visible');
          this.hidden = true;
        }
      }
    }
  );
}
